import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { Currency } from 'ui-toolkit/components';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';
import { IWireDepositData } from '../../../../../types/order/escrow/IWireDepositData';
import { getEscrowBankAccountLabel } from '../../../../../ui-toolkit/utilities/getEscrowBankAccountLabel';
import { getMismatchMessage } from '../../shared/getMismatchMessage';
import React from 'react';
import { prettyPayerType } from '../../../../../types/order/escrow/ePayerType';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

interface IColumnArgs {
  order: IOrderDetailsData;
  isSpruceWithZillowEnabled: boolean;
  isZillowClosingEnabled: boolean;
}
export const generateWireDepositTableColumns = ({
  order,
  isSpruceWithZillowEnabled,
  isZillowClosingEnabled,
}: IColumnArgs): IBootstrapTableColumnProps<IWireDepositData>[] => {
  return [
    {
      text: 'Amount',
      dataField: 'amountCents',
      sort: true,
      formatter: (cell: any, row?: IWireDepositData) => {
        return row && <Currency value={cell} valueIsCents emptyContent={''} />;
      },
    },
    {
      text: 'Payer Type',
      dataField: 'payerType',
      sort: true,
      formatter: (cell: any) => prettyPayerType[cell],
    },
    {
      text: 'Identifier',
      dataField: 'wireIdentifier',
      sort: true,
    },
    {
      text: 'Spruce Account Label',
      dataField: 'escrowBankAccount',
      sort: true,
      formatter: (cell: any) => getEscrowBankAccountLabel(cell, isSpruceWithZillowEnabled, isZillowClosingEnabled),
    },
    {
      text: 'Spruce Account #',
      dataField: 'escrowBankAccount.accountNumber',
      sort: true,
    },
    {
      text: 'Spruce Routing #',
      dataField: 'escrowBankAccount.fedWireRoutingNumber.routingNumber',
      sort: true,
    },
    {
      text: 'Wire Details',
      dataField: 'actualWireDetail',
      sort: true,
      formatter: (cell: any) => JSON.stringify(cell),
    },
    {
      text: 'Completed At',
      dataField: 'completedAtDate',
      formatter: (cell: any) => getDateString(DateFormat.hugeDate, cell),
      sort: true,
    },
    {
      text: 'Mismatched',
      dataField: 'matched',
      formatter: (cell: any, row?: IWireDepositData) => {
        return row && getMismatchMessage(order.orderInformation.created, row.matched);
      },
      sort: true,
    },
  ];
};
